import {
  ChangeDetectorRef,
  Directive,
  HostBinding,
  HostListener,
  Input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

@Directive({
    selector: '[cdkDetailRow]',
    standalone: false
})
export class CdkDetailRowDirective {
  private row: any;
  private tRef: TemplateRef<any>;
  private opened: boolean;

  static others: any[] = [];

  @HostBinding('class.expanded')
  get expended(): boolean {
    return this.opened;
  }

  @Input()
  set cdkDetailRow(value: any) {
    if (value !== this.row) {
      this.row = value;
    }
  }

  @Input('cdkDetailRowTpl')
  set template(value: TemplateRef<any>) {
    if (value !== this.tRef) {
      this.tRef = value;
    }
  }

  constructor(public vcRef: ViewContainerRef, private cdr: ChangeDetectorRef) {}

  @HostListener('click')
  onClick(): void {
    this.toggle();
  }

  toggle(): void {
    this.vcRef.clear();
    CdkDetailRowDirective.others.forEach(element => {
      element.vcRef.clear();
    });
    CdkDetailRowDirective.others = [];
    if (!this.opened) {
      this.render();
    }
    this.opened = this.vcRef.length > 0;
  }

  private render(): void {
    if (this.tRef && this.row) {
      CdkDetailRowDirective.others.push(this);
      this.vcRef.createEmbeddedView(this.tRef, { $implicit: this.row });
    }
  }
}
